import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon, EyeSlashIcon } from '../../assets/icons/icons';
import logo from '../../assets/new-logo.png';
import { supabase } from '../../supabaseClient';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setValidationErrors({});

    let errors = {};

    if (!password) {
      errors.password = 'Password is required';
    }

    if (!confirmPassword) {
      errors.confirmPassword = 'Confirm Password is required';
    } else if (password && password !== confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);

    try {
      // Updates the user's password using the access token from the reset URL
      const { error } = await supabase.auth.updateUser({
        password: password
      });

      if (error) {
        const errMsg = error.message.toLowerCase();
        if (errMsg.includes('expired')) {
          setError('This password reset link has expired. Please request a new password reset email.');
        } else if (errMsg.includes('used')) {
          setError('This password reset link has already been used. Please request a new password reset email.');
        } else if (errMsg.includes('session') || errMsg.includes('token') || errMsg.includes('invalid')) {
          setError('This password reset link is invalid. Please request a new password reset email.');
        } else {
          // Display specific error like weak password, network issues, etc.
          setError(error.message);
        }
      } else {
        setSubmitted(true);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while resetting the password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <div className="write-section">
        <div className="modal-content">
          <div className="login-logo-container">
            <img src={logo} className="login-logo" alt="Logo" />
          </div>
          <h2>Set New Password</h2>
          
          {submitted ? (
            <div className="success-message">
              <p>Your password has been successfully reset.</p>
              <button className="login-button" onClick={() => navigate('/login')} style={{ marginTop: '20px' }}>
                Return to Login
              </button>
            </div>
          ) : (
            <>
              {error && <p className="error-message">{error}</p>}
              <form onSubmit={handleSubmit} noValidate>
                <label>New Password:</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value);
                      if (validationErrors.password) setValidationErrors(p => ({ ...p, password: null }));
                    }}
                    placeholder="New Password"
                    className={`login-input ${validationErrors.password ? 'error' : ''}`}
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(v => !v)}
                  >
                    {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
                  </span>
                </div>
                {validationErrors.password && <div className="validation-error">{validationErrors.password}</div>}

                <label>Confirm New Password:</label>
                <div className="password-input-container">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={e => {
                      setConfirmPassword(e.target.value);
                      if (validationErrors.confirmPassword) setValidationErrors(p => ({ ...p, confirmPassword: null }));
                    }}
                    placeholder="Confirm New Password"
                    className={`login-input ${validationErrors.confirmPassword ? 'error' : ''}`}
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowConfirmPassword(v => !v)}
                  >
                    {showConfirmPassword ? <EyeIcon /> : <EyeSlashIcon />}
                  </span>
                </div>
                {validationErrors.confirmPassword && <div className="validation-error">{validationErrors.confirmPassword}</div>}

                <button type="submit" className="login-button" style={{ marginTop: '10px' }}>
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
